if (!customElements.get('cart-subscription-toggle')) {
  customElements.define(
    'cart-subscription-toggle',
    class CartSubscriptionToggle extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('#subscription-btn');
        this.infoText = this.querySelector('.subscription-info');
        this.isClicked = this.button?.classList.contains('checked');
        this.subscriptionContainer = this.parentElement.parentElement.querySelector('.cart-item__subscription-wrapper');
        this.cartItem = this.closest('.cart-item');
        this.sellingPlanHandler = this.cartItem.querySelector('selling-plan-select');
        this.checkoutButton = document.querySelector('#CartDrawer-Checkout');
      }

      connectedCallback() {
        if (this.button) this.button.addEventListener('click', this.toggleButton.bind(this));
        if (this.infoText) this.infoText.addEventListener('click', this.toggleButton.bind(this));
      }

      toggleButton(e) {
        e.preventDefault();

        if (this.isClicked) {
          this.isClicked = false;
          this.button.classList.remove('checked');
          this.subscriptionContainer.classList.add('hidden');
          if (this.sellingPlanHandler.selectedPlanId != '') {
            this.sellingPlanHandler.selectedPlanId = '';
            this.sellingPlanHandler?.debouncedUpdatePlan();
          }
        } else {
          this.isClicked = true;
          this.button.classList.add('checked');
          this.subscriptionContainer.classList.remove('hidden');
        }
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.toggleButton.bind(this));
        if (this.infoText) this.infoText.removeEventListener('click', this.toggleButton.bind(this));
      }
    }
  );
}
